export default __webpack_public_path__ + "static/media/Caveat-Variable.557171cb.ttf";